export default "__VITE_PUBLIC_ASSET__f939395a__"